import { EducationInfo } from '../../../../../store/workspace/types';
import { EditIcon, TrashIcon } from '../../../../../assets/icons/common';
import { useDispatch } from '../../../../../store/store';
import styles from './style.module.scss';
import {
    setAddEducationModal,
    setEducationEditMode,
    setSelectedEducation,
    setDeleteEducationModal,
} from '../../../../../store/workspace/slice';

interface Props {
    data: EducationInfo[] | undefined;
};

export default function Education(props: Props) {
    const { data } = props;
    const dispatch = useDispatch();
    const copyOfData = (data && Array.isArray(data)) ? [...data] : null;
    const sortByDate = copyOfData ? copyOfData.sort((a, b) => new Date(a.from).getTime() - new Date(b.from).getTime()) : null;

    const editEducation = (item: EducationInfo) => {
        dispatch(setEducationEditMode(true));
        dispatch(setSelectedEducation(item));
        dispatch(setAddEducationModal(true));
    };

    const deleteEducation = (item: EducationInfo) => {
        dispatch(setSelectedEducation(item));
        dispatch(setDeleteEducationModal(true));
    };

    return (
        <div className={styles.wrapper}>
            {data && data.length === 0 && <span>I don't have education experience.</span>}
            {sortByDate?.map((item, indx) => <div className={styles.content}>
                <div className={styles.content_headbar}>
                    <span className={styles.content_headbar_title}>Degree {indx + 1}</span>
                    <div className={styles.content_headbar_actions}>
                        <EditIcon onClick={() => editEducation(item)} />
                        <TrashIcon onClick={() => deleteEducation(item)} />
                    </div>
                </div>
                <div className={styles.content_main}>
                    <div className={styles.content_main_row}>
                        <span className={styles.content_main_row_prop}>School  or university</span>
                        <span className={styles.content_main_row_val}>{item.universityName}</span>
                    </div>
                    <div className={styles.content_main_row}>
                        <span className={styles.content_main_row_prop}>Degree</span>
                        <span className={styles.content_main_row_val}>{item.degree}</span>
                    </div>
                    <div className={styles.content_main_row}>
                        <span className={styles.content_main_row_prop}>Field of study</span>
                        <span className={styles.content_main_row_val}>{item.field}</span>
                    </div>
                    <div className={styles.content_main_row}>
                        <span className={styles.content_main_row_prop}>Overal result (GPA)</span>
                        <span className={styles.content_main_row_val}>{item.GPA}</span>
                    </div>
                    <div className={styles.content_main_row}>
                        <span className={styles.content_main_row_prop}>Date</span>
                        <span className={styles.content_main_row_val}>{item.from} - {item.to || 'Present'}</span>
                    </div>
                </div>
            </div>)}
            <div
                className={styles.add_btn}
                onClick={() => dispatch(setAddEducationModal(true))}
            >
                <span>+ Add degree</span>
            </div>
        </div>
    )
}
